import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";

const StageHistoryModal = ({
  open,
  onClose,
  leadId,
  authToken,
}) => {
  const [stageHistoryData, setStageHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(open, leadId, "open and leadId");
    if (open && leadId) {
      getStageHistory();
    }
  }, [open, leadId]);

  const getStageHistory = async () => {
    try {
      setLoading(true);

      const result = await apiHandler({
        url: `${endpoint.GET_LOAN_SENDBACK_HISTORY}/${leadId}`,
        method: "GET",
        authToken,
      });

      setStageHistoryData(
        Array.isArray(result?.data) ? result.data : []
      );
    } catch (error) {
      console.error("Error fetching stage history:", error);
      setStageHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  const getStageLabel = (source) => {
    const stageMap = {
      INPROCESS: "In Process",
      DISBURSAL_INITIATED: "Disbursal",
      DEVIATION: "Deviation",
      PRE_SANCTIONED: "Sanction Authority",
      COMPLETED: "LMS Checker",
    };

    return stageMap?.[source] || source || "-";
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: {
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "18px 24px",
          background: "#f7f8fa",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <div>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "#17324d",
            }}
          >
            Stage History
          </Typography>

          <Typography
            style={{
              fontSize: "13px",
              color: "#777",
              marginTop: "3px",
            }}
          >
            Application ID: {leadId}
          </Typography>
        </div>

        <IconButton
          onClick={onClose}
          size="small"
          style={{
            color: "#555",
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent
        style={{
          padding: "20px 24px",
          background: "#fff",
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "180px",
            }}
          >
            <CircularProgress />
          </div>
        ) : stageHistoryData.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "50px 20px",
            }}
          >
            <Typography
              style={{
                color: "#777",
                fontSize: "14px",
              }}
            >
              No stage history found.
            </Typography>
          </div>
        ) : (
          <TableContainer
            component={Paper}
            elevation={0}
            style={{
              border: "1px solid #e4e7eb",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <Table>
              <TableHead>
                <TableRow
                  style={{
                    background: "#f5f6f8",
                  }}
                >
                  <TableCell style={headerStyle}>
                    Application ID
                  </TableCell>
                  <TableCell style={headerStyle}>
                    Stage
                  </TableCell>
                  <TableCell style={headerStyle}>
                    Updated By
                  </TableCell>
                  <TableCell style={headerStyle}>
                    Return Date
                  </TableCell>
                  <TableCell style={headerStyle}>
                    Remarks
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {stageHistoryData.map((item, index) => (
                  <TableRow
                    key={index}
                    hover
                    style={{
                      background:
                        index % 2 === 0 ? "#ffffff" : "#fafafa",
                    }}
                  >
                    <TableCell style={cellStyle}>
                      {item?.loanApplicationId || "-"}
                    </TableCell>
                    <TableCell style={cellStyle}>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "5px 12px",
                          borderRadius: "20px",
                          background: "#fff0e9",
                          color: "#e85d04",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        {getStageLabel(item?.source) || "-"}
                      </span>
                    </TableCell>
                    <TableCell style={cellStyle}>
                      {item?.username || "-"}
                    </TableCell>
                    <TableCell style={cellStyle}>
                      {formatDate(item?.returnDate)}
                    </TableCell>
                    <TableCell style={cellStyle}>
                      {item?.remarks || "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions
        style={{
          padding: "12px 24px",
          borderTop: "1px solid #e5e7eb",
          background: "#fafafa",
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          style={{
            background: "#4b5563",
            color: "#fff",
            textTransform: "uppercase",
            fontSize: "12px",
            fontWeight: 600,
            padding: "9px 24px",
            borderRadius: "6px",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const headerStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#4b5563",
  padding: "14px 16px",
  whiteSpace: "nowrap",
};

const cellStyle = {
  fontSize: "13px",
  color: "#333",
  padding: "15px 16px",
};

export default StageHistoryModal;